// extracted by mini-css-extract-plugin
export default {"kontakt":"Kontakt_kontakt__94+gM","location":"Kontakt_location__gaOc1","line":"Kontakt_line__G014B"};